var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("salesReport.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.searchVal,
                    size: "small",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _vm.role == "RSM"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("salesReport.form.asmEmp") } },
                        [
                          _c("FormInput", {
                            attrs: { val: _vm.searchVal.asmName },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "asmName",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.role == "Sales leader" || _vm.role == "DA"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("salesReport.form.rsmEmp") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("common.pleaseSelect"),
                              },
                              model: {
                                value: _vm.searchVal.rsmNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "rsmNo", $$v)
                                },
                                expression: "searchVal.rsmNo",
                              },
                            },
                            _vm._l(_vm.RSMList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.empName,
                                  value: item.empNo,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("salesReport.form.spName") } },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.spName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "spName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { staticClass: "main-table-container" },
        [
          _c(
            "div",
            { attrs: { slot: "header-info" }, slot: "header-info" },
            [
              [
                _c("div", { staticClass: "title-wrap" }, [
                  _c("span", { staticClass: "panel-title" }, [
                    _vm._v(_vm._s(_vm.$t("salesReport.BoxWrap.list")) + " "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "padding-left": "20px",
                        color: "#004EA8",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("salesReport.common.lastUpdateTime") +
                            " : " +
                            this.lastUpdateTime
                        )
                      ),
                    ]
                  ),
                ]),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "header-right" }, slot: "header-right" },
            [
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{pageName, list: ['EXPORT']}",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(
                          _vm.$t("salesReport.common.exportText")
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.export")))]
                ),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _vm.role == "ASM"
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table.listLoading,
                      expression: "table.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table.list,
                    stripe: "",
                    border: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "spName",
                      label: _vm.$t("salesReport.table.spName"),
                      width: "200",
                      fixed: "",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditStatus",
                      width: "150",
                      label: _vm.$t("salesReport.table.auditStatus"),
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                [
                                  scope.row.auditStatus == "0"
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { type: "warning" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatEnum(
                                                scope.row.auditStatus,
                                                "auditEMEOptions"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.auditStatus == "1"
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { type: "danger" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatEnum(
                                                scope.row.auditStatus,
                                                "auditEMEOptions"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.auditStatus == "2"
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { type: "text" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatEnum(
                                                scope.row.auditStatus,
                                                "auditEMEOptions"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.auditStatus == null &&
                                  scope.row.spSapId != "ALL"
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { type: "info" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "salesReport.common.unSubmit"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2464579099
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderQty",
                      label: _vm.$t("salesReport.table.orderQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.orderQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.orderQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3213167881
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deliverQty",
                      label: _vm.$t("salesReport.table.deliverQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.deliverQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.deliverQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      124952649
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "receiptQty",
                      label: _vm.$t("salesReport.table.receiptQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.receiptQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.receiptQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1867915337
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "salesTargetQty",
                      label: _vm.$t("salesReport.table.salesTargetQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.salesTargetQty) ==
                                      0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.salesTargetQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      506156169
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekTotalQty",
                      label: _vm.$t("salesReport.table.emeWeekTotalQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekTotalQty) ==
                                      0
                                      ? "-"
                                      : _vm.paddingNum(
                                          scope.row.emeWeekTotalQty
                                        )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2084434985
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekOneQty",
                      label: _vm.$t("salesReport.table.emeWeekOneQty"),
                      width: "150",
                      align: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.edit && scope.row.auditStatus != null
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.paddingNum(scope.row.emeWeekOneQty)
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              (scope.row.auditStatus == null &&
                                scope.row.spSapId != "ALL") ||
                              scope.row.edit
                                ? _c("FormInputNumber", {
                                    attrs: { val: scope.row.emeWeekOneQty },
                                    on: {
                                      "update:val": function (v) {
                                        return _vm.updateFormValue(
                                          v,
                                          "emeWeekOneQty",
                                          scope.row
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3610617033
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekTwoQty",
                      label: _vm.$t("salesReport.table.emeWeekTwoQty"),
                      width: "150",
                      align: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.edit && scope.row.auditStatus != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.paddingNum(scope.row.emeWeekTwoQty)
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              (scope.row.auditStatus == null &&
                                scope.row.spSapId != "ALL") ||
                              scope.row.edit
                                ? _c("FormInputNumber", {
                                    attrs: { val: scope.row.emeWeekTwoQty },
                                    on: {
                                      "update:val": function (v) {
                                        return _vm.updateFormValue(
                                          v,
                                          "emeWeekTwoQty",
                                          scope.row
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2597273494
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekThreeQty",
                      label: _vm.$t("salesReport.table.emeWeekThreeQty"),
                      width: "150",
                      align: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.edit && scope.row.auditStatus != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.paddingNum(
                                          scope.row.emeWeekThreeQty
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              (scope.row.auditStatus == null &&
                                scope.row.spSapId != "ALL") ||
                              scope.row.edit
                                ? _c("FormInputNumber", {
                                    attrs: { val: scope.row.emeWeekThreeQty },
                                    on: {
                                      "update:val": function (v) {
                                        return _vm.updateFormValue(
                                          v,
                                          "emeWeekThreeQty",
                                          scope.row
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2575691988
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekFourQty",
                      label: _vm.$t("salesReport.table.emeWeekFourQty"),
                      width: "150",
                      align: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.edit && scope.row.auditStatus != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.paddingNum(scope.row.emeWeekFourQty)
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              (scope.row.auditStatus == null &&
                                scope.row.spSapId != "ALL") ||
                              scope.row.edit
                                ? _c("FormInputNumber", {
                                    attrs: { val: scope.row.emeWeekFourQty },
                                    on: {
                                      "update:val": function (v) {
                                        return _vm.updateFormValue(
                                          v,
                                          "emeWeekFourQty",
                                          scope.row
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3701437908
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekFiveQty",
                      label: _vm.$t("salesReport.table.emeWeekFiveQty"),
                      width: "150",
                      align: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.edit && scope.row.auditStatus != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.paddingNum(scope.row.emeWeekFiveQty)
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              (scope.row.auditStatus == null &&
                                scope.row.spSapId != "ALL") ||
                              scope.row.edit
                                ? _c("FormInputNumber", {
                                    attrs: { val: scope.row.emeWeekFiveQty },
                                    on: {
                                      "update:val": function (v) {
                                        return _vm.updateFormValue(
                                          v,
                                          "emeWeekFiveQty",
                                          scope.row
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      97521190
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekChangeQty",
                      label: _vm.$t("salesReport.table.emeWeekChangeQty"),
                      width: "150",
                      align: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.edit && scope.row.auditStatus != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.paddingNum(
                                          scope.row.emeWeekChangeQty
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              (scope.row.auditStatus == null &&
                                scope.row.spSapId != "ALL") ||
                              scope.row.edit
                                ? _c("FormInputNumber", {
                                    attrs: { val: scope.row.emeWeekChangeQty },
                                    on: {
                                      "update:val": function (v) {
                                        return _vm.updateFormValue(
                                          v,
                                          "emeWeekChangeQty",
                                          scope.row
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      844688476
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      label: _vm.$t("salesReport.table.action"),
                      align: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.auditStatus == null || scope.row.edit
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-2 t-search-btn",
                                      attrs: { icon: "el-icon-success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.saveBtnClick(scope.row, 2)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("salesReport.common.submit")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.edit == true
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-2 t-search-btn",
                                      attrs: { icon: "el-icon-error" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editBtnClick(
                                            scope.row,
                                            false
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("salesReport.common.cancel")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (scope.row.auditStatus == "1" ||
                                scope.row.auditStatus == "2") &&
                              !scope.row.edit
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-2 t-search-btn",
                                      attrs: { icon: "el-icon-edit" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editBtnClick(
                                            scope.row,
                                            true
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("salesReport.common.edit")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1212510057
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.role == "RSM"
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table.listLoading,
                      expression: "table.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table.list,
                    stripe: "",
                    border: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("salesReport.table.asmEmp"),
                      width: "150",
                      fixed: "",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "spName",
                      label: _vm.$t("salesReport.table.spName"),
                      width: "200",
                      fixed: "",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditStatus",
                      width: "100",
                      label: _vm.$t("salesReport.table.auditStatus"),
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                [
                                  scope.row.auditStatus == "0"
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { type: "warning" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatEnum(
                                                scope.row.auditStatus,
                                                "auditEMEOptions"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.auditStatus == "1"
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { type: "danger" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatEnum(
                                                scope.row.auditStatus,
                                                "auditEMEOptions"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.auditStatus == "2"
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { type: "text" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatEnum(
                                                scope.row.auditStatus,
                                                "auditEMEOptions"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.auditStatus == null &&
                                  scope.row.spSapId != "ALL"
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { type: "info" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "salesReport.common.unSubmit"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2464579099
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderQty",
                      label: _vm.$t("salesReport.table.orderQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.orderQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.orderQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3213167881
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deliverQty",
                      label: _vm.$t("salesReport.table.deliverQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.deliverQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.deliverQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      124952649
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "receiptQty",
                      label: _vm.$t("salesReport.table.receiptQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.receiptQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.receiptQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1867915337
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "salesTargetQty",
                      label: _vm.$t("salesReport.table.salesTargetQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.salesTargetQty) ==
                                      0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.salesTargetQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      506156169
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekTotalQty",
                      label: _vm.$t("salesReport.table.emeWeekTotalQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekTotalQty) ==
                                      0
                                      ? "-"
                                      : _vm.paddingNum(
                                          scope.row.emeWeekTotalQty
                                        )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2084434985
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekOneQty",
                      label: _vm.$t("salesReport.table.emeWeekOneQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekOneQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3885032382
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekTwoQty",
                      label: _vm.$t("salesReport.table.emeWeekTwoQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekTwoQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4114449025
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekThreeQty",
                      label: _vm.$t("salesReport.table.emeWeekThreeQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekThreeQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2626096003
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekFourQty",
                      label: _vm.$t("salesReport.table.emeWeekFourQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekFourQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3699709827
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekFiveQty",
                      label: _vm.$t("salesReport.table.emeWeekFiveQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekFiveQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1088564273
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekChangeQty",
                      label: _vm.$t("salesReport.table.emeWeekChangeQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekChangeQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1874923147
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      label: _vm.$t("salesReport.table.action"),
                      align: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.auditStatus == "0"
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-2 t-search-btn",
                                      attrs: { icon: "el-icon-success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.approveBtnClick(
                                            scope.row,
                                            2
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("salesReport.table.approve")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.auditStatus == "0"
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-2 t-search-btn-red",
                                      attrs: { icon: "el-icon-error" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.approveBtnClick(
                                            scope.row,
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("salesReport.table.reject")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1330293910
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.role !== "ASM" && _vm.role !== "RSM"
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table.listLoading,
                      expression: "table.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table.list,
                    stripe: "",
                    border: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("salesReport.table.rsmEmp"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "spName",
                      label: _vm.$t("salesReport.table.spName"),
                      width: "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderQty",
                      label: _vm.$t("salesReport.table.orderQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.orderQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.orderQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3213167881
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deliverQty",
                      label: _vm.$t("salesReport.table.deliverQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.deliverQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.deliverQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      124952649
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "receiptQty",
                      label: _vm.$t("salesReport.table.receiptQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.receiptQty) == 0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.receiptQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1867915337
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "salesTargetQty",
                      label: _vm.$t("salesReport.table.salesTargetQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.salesTargetQty) ==
                                      0
                                      ? "-"
                                      : _vm.paddingNum(scope.row.salesTargetQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      506156169
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekTotalQty",
                      label: _vm.$t("salesReport.table.emeWeekTotalQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekTotalQty) ==
                                      0
                                      ? "-"
                                      : _vm.paddingNum(
                                          scope.row.emeWeekTotalQty
                                        )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2084434985
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekOneQty",
                      label: _vm.$t("salesReport.table.emeWeekOneQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekOneQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3885032382
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekTwoQty",
                      label: _vm.$t("salesReport.table.emeWeekTwoQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekTwoQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4114449025
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekThreeQty",
                      label: _vm.$t("salesReport.table.emeWeekThreeQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekThreeQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2626096003
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekFourQty",
                      label: _vm.$t("salesReport.table.emeWeekFourQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekFourQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3699709827
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekFiveQty",
                      label: _vm.$t("salesReport.table.emeWeekFiveQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekFiveQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1088564273
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "emeWeekChangeQty",
                      label: _vm.$t("salesReport.table.emeWeekChangeQty"),
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.paddingNum(scope.row.emeWeekChangeQty)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1874923147
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.table.total > 0,
                expression: "table.total>0",
              },
            ],
            attrs: {
              total: _vm.table.total,
              page: _vm.table.currPage,
              limit: _vm.table.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.table, "currPage", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.table, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }